import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class ExtratoCoparticipacaoService extends Service {
  async consultarExtratoResumido (codServidor) {
    let extrato = [];
    let result = await this.getExtratoApi().consultarExtratoResumido(codServidor);
    extrato = result;

    return extrato;
  }
  async consultarBeneficiarioExtrato (filter) {
    let extrato = [];
    let result = await this.getExtratoApi().consultarBeneficiarioExtrato(filter);
    extrato = result;

    return extrato;
  }
  async consultarPrestadorExtrato (filter) {
    let extrato = [];
    let result = await this.getExtratoApi().consultarPrestadorExtrato(filter);
    extrato = result;

    return extrato;
  }
  async consultarProcedimentoExtrato (filter) {
    let extrato = [];
    let result = await this.getExtratoApi().consultarProcedimentoExtrato(filter);
    extrato = result;

    return extrato;
  }
  async consultarDataInicioAdesao (codServidor) {
    let dataDeReferencia = '';
    let result = await this.getExtratoApi().consultarDataInicioAdesao(codServidor);
    dataDeReferencia = result;

    return dataDeReferencia;
  }
  async consultarDividaEmAberto (filter) {
    let dividaEmAberto = '';
    let result = await this.getExtratoApi().consultarDividaEmAberto(filter);
    dividaEmAberto = result;
    return dividaEmAberto;
  }
  async consultarDividaEmAbertoBeneficiario (filter) {
    let dividaEmAberto = [];
    let result = await this.getExtratoApi().consultarDividaEmAbertoBeneficiario(filter);
    dividaEmAberto = result;
    return dividaEmAberto;
  }
  async consultarDividaProcedimentoExtrato (carteira, seqDivida, ano, mes) {
    let dividaEmAberto = [];
    let result = await this.getExtratoApi().consultarDividaProcedimentoExtrato(carteira, seqDivida, ano, mes);
    dividaEmAberto = result;
    return dividaEmAberto;
  }

  async isFolhaFechada () {
    let isFolhaFechada = await this.getExtratoApi().isFolhaFechada();
    return isFolhaFechada;
  }
  async getDataUltimoFechamentoFolha () {
    let dataFechamentoFolha = await this.getExtratoApi().getDataUltimoFechamentoFolha();
    return dataFechamentoFolha;
  }

  async consultarExtratoCoparticipacaoCompleto ({carteira, from, to, incluirDependentes}) {
    let extrato = [];

    let result = await this.getExtratoApi().consultarExtratoCoparticipacaoCompleto({carteira, from, to, incluirDependentes});
    extrato = result;

    return extrato;
  }

  async consultarExtratoDividaCompleto ({carteira, ano, mes, incluirDependentes}) {
    let extrato = [];

    let result = await this.getExtratoApi().consultarExtratoDividaCompleto({carteira, ano, mes, incluirDependentes});
    extrato = result;

    return extrato;
  }
}
export default ExtratoCoparticipacaoService;
